export const GET_USER = "GET_USER";
export const GET_PASSWORD_USER = "GET_PASSWORD_USER";
export const GET_TERMS_CONDITIONS = "GET_TERMS_CONDITIONS";
export const GET_STATE_LOADING_PASSWORD_VALIDATION = "GET_STATE_LOADING_PASSWORD_VALIDATION";
